import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://app.wehandleship.com/img/logos/ShipBreeze-Horizontal-White@3x.png",
  style: {"max-width":"180px"},
  alt: "logo-icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_8 = { class: "sidebar-nav-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-shopping-cart" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Orders", -1)
const _hoisted_11 = { class: "sidebar-nav-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Issues", -1)
const _hoisted_14 = { class: "sidebar-nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseProducts",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseProducts"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-barcode" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Products")
], -1)
const _hoisted_16 = {
  id: "sidebarCollapseProducts",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_17 = { class: "accordion-body" }
const _hoisted_18 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_19 = { class: "sidebar-sub-menu-item" }
const _hoisted_20 = { class: "sidebar-sub-menu-item" }
const _hoisted_21 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseInventory",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseInventory"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-list" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Inventory")
], -1)
const _hoisted_23 = {
  id: "sidebarCollapseInventory",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_24 = { class: "accordion-body" }
const _hoisted_25 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_26 = { class: "sidebar-sub-menu-item" }
const _hoisted_27 = { class: "sidebar-sub-menu-item" }
const _hoisted_28 = { class: "sidebar-sub-menu-item" }
const _hoisted_29 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseWholesale",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseWholesale"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-storefront" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Wholesale")
], -1)
const _hoisted_31 = {
  id: "sidebarCollapseWholesale",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_32 = { class: "accordion-body" }
const _hoisted_33 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_34 = { class: "sidebar-sub-menu-item" }
const _hoisted_35 = { class: "sidebar-sub-menu-item" }
const _hoisted_36 = { class: "sidebar-nav-item" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-arc-left" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Returns", -1)
const _hoisted_39 = { class: "sidebar-nav-item" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-project" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Special Projects", -1)
const _hoisted_42 = { class: "sidebar-nav-item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/orders",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/issues",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("ul", _hoisted_18, [
                _createElementVNode("li", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: "/stock-products",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Stock Products ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: "/products",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Virtual Products ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("ul", _hoisted_25, [
                _createElementVNode("li", _hoisted_26, [
                  _createVNode(_component_router_link, {
                    to: "/inventory",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Current Inventory ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    to: "/inventory/reports",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reports ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    to: "/inventory/sold-vs-backorders",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sold vs Backorders ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("ul", _hoisted_33, [
                _createElementVNode("li", _hoisted_34, [
                  _createVNode(_component_router_link, {
                    to: "/wholesale/orders",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Merchant Orders ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_35, [
                  _createVNode(_component_router_link, {
                    to: "/wholesale/customers",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Customers ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_36, [
          _createVNode(_component_router_link, {
            to: "/returns",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_39, [
          _createVNode(_component_router_link, {
            to: "/special-projects",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_40,
              _hoisted_41
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_42, [
          _createVNode(_component_router_link, {
            to: "/logout",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_43,
              _hoisted_44
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}